/* MDAiRE — horizontal scroll-snap carousel.
   Markup contract:
     <div data-mda-carousel>
       <div data-mda-carousel-track>
         <!-- direct children = slides -->
       </div>
       <button data-mda-carousel-prev>...</button>
       <button data-mda-carousel-next>...</button>
     </div>
   The buttons can live anywhere inside the carousel root; they don't have
   to be siblings of the track. The script wires click + keyboard arrows,
   updates disabled state at the ends, and recomputes on resize. */
class MdaCarousel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-mda-carousel-track]');
    if (!this.track) return;
    this.prev = root.querySelector('[data-mda-carousel-prev]');
    this.next = root.querySelector('[data-mda-carousel-next]');

    this.prev && this.prev.addEventListener('click', () => this.advance(-1));
    this.next && this.next.addEventListener('click', () => this.advance(1));
    this.track.addEventListener('scroll', () => this.updateNav(), { passive: true });
    window.addEventListener('resize', () => this.updateNav(), { passive: true });

    this.updateNav();
  }

  advance(direction) {
    const first = this.track.firstElementChild;
    if (!first) return;
    const styles = getComputedStyle(this.track);
    const gap = parseInt(styles.columnGap || styles.gap || 0, 10) || 0;
    const step = first.getBoundingClientRect().width + gap;
    this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  updateNav() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    const x = this.track.scrollLeft;
    const atStart = x <= 1;
    const atEnd = x >= max - 1;
    if (this.prev) this.prev.toggleAttribute('disabled', atStart);
    if (this.next) this.next.toggleAttribute('disabled', atEnd);
    this.root.toggleAttribute('data-mda-carousel-overflow', max > 1);
  }
}

const init = () => document.querySelectorAll('[data-mda-carousel]:not([data-mda-carousel-initialized])').forEach(el => {
  el.setAttribute('data-mda-carousel-initialized', '');
  new MdaCarousel(el);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('shopify:section:load', init);
